import { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { oktaAuthApiRef } from '@backstage/core-plugin-api';
import {
  IdentityProviders,
  SignInPage,
  SignInProviderConfig,
} from '@backstage/core-components';

const oktaProvider: SignInProviderConfig = {
  id: 'okta-auth-provider',
  title: 'Okta',
  message: 'Sign in using Okta',
  apiRef: oktaAuthApiRef,
};

export const signInPage: ExtensionDefinition = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const providers: IdentityProviders =
        process.env.NODE_ENV === 'production'
          ? [oktaProvider]
          : ['guest', oktaProvider];
      return <SignInPage {...props} providers={providers} />;
    },
  },
});
